<template>
  <transition name="detail">
    <section class="detail">
      <div class="detail__content" ref="detailContent">
        <slot></slot>
      </div>
      <button class="detail__close-button" @click="handleCloseLayer">닫기</button>
    </section>
  </transition>
</template>

<script>
  import {mapMutations, mapGetters} from "vuex";

  export default {
    name: "Detail",
    methods: {
      ...mapMutations([
        "isLayerView",
      ]),
      handleCloseLayer() {
        window.nowPlayingVideo && window.nowPlayingVideo.stop();
        this.isLayerView(false);
      },
    },
    computed: {
      ...mapGetters([
        "activeLayer",
      ]),
    },
    mounted() {
      this.$nextTick(() => {
        this.$refs.detailContent.style.marginTop = `-${this.$refs.detailContent.offsetHeight / 2}px`;
      });
    },
    watch: {
      activeLayer(value) {
        if (!value) return;
        this.$nextTick(() => {
          this.$refs.detailContent.style.marginTop = `-${this.$refs.detailContent.offsetHeight / 2}px`;
        });
      },
    },
  };
</script>

<style lang="scss">
  .detail {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 11;
    min-width:1700px;

    &__title {
      margin: 0 0 10px 0;
      font-size: 0;
      text-align: center;
    }

    &__sub-title {
      text-align: center;
      margin: 0 0 40px 0;
    }

    &__content {
      position: relative;
      z-index: 3;
      top: 50%;
      left: 0;
    }

    &:after {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background: rgba(0, 0, 0, 0.92);
      z-index: 1;
    }

    &__close-button {
      width: 42px;
      height: 40px;
      position: absolute;
      outline: 0;
      border: 0;
      top: 90px;
      right: 55px;
      z-index: 4;
      @include bg($bg: 'img/detail/btn-detail-close.png', $position: 0 0);
      @include hide-text;
    }

    &-enter-active,
    &-leave-active {
      transition: all .3s ease-in-out;
    }

    &-enter,
    &-leave-to {
      opacity: 0;
      transform: scale(1) translateY(0px);
    }
  }

  .slide-dot-area {
    white-space: nowrap;
    text-align: center;
    padding-top: 44px;
    height: 10px;

    &__button {
      display: inline-block;
      width: 37px;
      height: 3px;
      padding: 4px 0;
      margin: 0 4px;
      outline: 0;
      border: 0;
      position: relative;

      @include hide-text;

      &:before {
        content: '';
        display: block;
        background: #797979;
        width: 37px;
        height: 3px;
        position: absolute;
        left: 0;
        top: 50%;
        margin-top: -2px;
      }

      &--active {
        &:before {
          background: #cdb367;
        }
      }
    }
  }

  .detail__tab {
    height: 48px;
    margin: 30px 0 28px 0;
    text-align: center;

    &-button {
      cursor: pointer;
      display: inline-block;
      width: 122px;
      height: 48px;
      overflow: hidden;
      text-indent: -99em;
      background: #000;
      margin: 0 3px;

      &--item1-1 {
        @include bg($bg: 'img/detail/item/item1-tab.png', $position: 0 0);
      }

      &--item1-2 {
        @include bg($bg: 'img/detail/item/item1-tab.png', $position: -127px 0);
      }

      &--item1-3 {
        @include bg($bg: 'img/detail/item/item1-tab.png', $position: -254px 0);
      }


      &--item2-1 {
        @include bg($bg: 'img/detail/item/item2-tab.png', $position: 0 0);
      }

      &--item2-2 {
        @include bg($bg: 'img/detail/item/item2-tab.png', $position: -127px 0);
      }

      &--item2-3 {
        @include bg($bg: 'img/detail/item/item2-tab.png', $position: -254px 0);
      }


      &--hunting1-1 {
        width: 175px;
        @include bg($bg: 'img/detail/hunting/hunting1-tab.png', $position: 0 0);
      }

      &--hunting1-2 {
        width: 132px;
        @include bg($bg: 'img/detail/hunting/hunting1-tab.png', $position: -179px 0);
      }

      &--hunting1-3 {
        width: 101px;
        @include bg($bg: 'img/detail/hunting/hunting1-tab.png', $position: -316px 0);
      }

      &--hunting1-4 {
        width: 122px;
        @include bg($bg: 'img/detail/hunting/hunting1-tab.png', $position: -422px 0);
      }

      &--hunting1-5 {
        width: 100px;
        @include bg($bg: 'img/detail/hunting/hunting1-tab.png', $position: -549px 0);
      }

      &--hunting1-6 {
        width: 127px;
        @include bg($bg: 'img/detail/hunting/hunting1-tab.png', $position: -654px 0);
      }


      &--active {
        cursor: default;
        background-position-y: -48px !important;
        pointer-events: none;
      }
    }


  }
</style>


